import Mention from "@tiptap/extension-mention";
import { ReactRenderer } from "@tiptap/react";
import tippy from "tippy.js";
import MentionList from "./MentionExtension";

export const createMentionExtension = (activeUsers: any[]) =>
  Mention.extend({
    addAttributes() {
      return {
        id: {
          default: null,
          parseHTML: el => el.getAttribute("data-mention-id"),
          renderHTML: attrs => ({
            "data-mention-id": attrs.id,
          }),
        },
        label: {
          default: null,
          parseHTML: el => el.getAttribute("label"),
          renderHTML: attrs => ({
            label: attrs.label,
          }),
        },
      };
    },
  }).configure({
    HTMLAttributes: {
      class: "mention",
      "data-type": "mention",
    },

    renderLabel({ node }) {
      return `@${node.attrs.label || ""}`;
    },

    suggestion: {
      char: "@",
      decorationClass: "mention-typing",

      items: ({ query }) => {
        return activeUsers
          ?.filter((user) =>
            user.name.toLowerCase().includes(query.toLowerCase())
          )
          .slice(0, 5);
      },

      render: () => {
        let component: any;
        let popup: any;
        let updatePosition: any;

        return {
          onStart: (props) => {
            component = new ReactRenderer(MentionList, {
              props,
              editor: props.editor,
            });

            popup = tippy(document.body, {
              getReferenceClientRect: () =>
                props.clientRect?.() ?? new DOMRect(0, 0, 0, 0),
              appendTo: () => document.body,
              content: component.element,
              showOnCreate: true,
              interactive: true,
              trigger: "manual",
              placement: "top-start",
              zIndex: 9999,
              popperOptions: {
                strategy: "fixed",   // 👈 THIS keeps it anchored while scrolling
              },
              theme: "mention",
            });
            updatePosition = () => {
              popup.setProps({
                getReferenceClientRect: props.clientRect,
              });
            };

            window.addEventListener("scroll", updatePosition, true);
            window.addEventListener("resize", updatePosition);
          },

          onUpdate(props) {
            component.updateProps(props);
            popup.setProps({
              getReferenceClientRect: props.clientRect,
            });
          },

          onKeyDown(props) {
            if (props.event.key === "Escape") {
              popup.hide();
              return true;
            }
            return component.ref?.onKeyDown(props);
          },

          onExit() {
            window.removeEventListener("scroll", updatePosition, true);
            window.removeEventListener("resize", updatePosition);
            popup.destroy();
            component.destroy();
          },
        };
      },
    },
  });
